import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import { Start, End } from './TestInfoDemo'
import TestInfoElement from './TestInfoElement'
import TestInfoFormBrand from './TestInfoFormBrand'
import { STYLE_FORM_SCHEMA } from './TestInfoFormStyle'
import TestInfoFormValue from './TestInfoFormValue'
import endTestInfoIcon from './assets/testInfoEnd.svg'
import startTestInfoIcon from './assets/testInfoStart.svg'

export const StartTestInfo = genElementConfig(CONFIG_ELEMENTS.testInfoStart, {
  label: t('elements.testInfoStart.label'),
  icon: startTestInfoIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestInfoElement,
  Demo: [Start],
  FormValue: TestInfoFormValue,
  FormBrand: TestInfoFormBrand,
  EditorActions: null,
})

export const EndTestInfo = genElementConfig(CONFIG_ELEMENTS.testInfoEnd, {
  label: t('elements.testInfoEnd.label'),
  icon: endTestInfoIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestInfoElement,
  Demo: [End],
  FormValue: TestInfoFormValue,
  FormBrand: TestInfoFormBrand,
  EditorActions: null,
})
